import { IQuestionField, useFormField } from '@cian/frontend-request-form-widget';

import * as React from 'react';

import { Multiselect as Component } from './Multiselect';

export const Multiselect: React.FC<IQuestionField> = props => {
  const {
    field: { value },
    helpers: { setValue },
  } = useFormField<string[]>({ name: props.name });

  const options = React.useMemo(
    () =>
      props.answers?.map(answer => ({
        label: answer.label,
        value: answer.value,
      })) || [],
    [],
  );

  return (
    <Component
      label={props.label}
      options={options}
      placeholder={props.placeholder}
      value={value}
      onChange={setValue}
    />
  );
};

Multiselect.displayName = 'MultiselectContainer';
